import { Injectable } from '@angular/core';
import {User} from '../model/user';

const TOKEN = 'token';
const USER = 'user';

@Injectable()
export class AuthenticationService {
  constructor() { }

  getCredentials() {
    return localStorage.getItem(TOKEN);
  }

  setUserOnLocalStorage(user: User) {
    localStorage.setItem(USER, JSON.stringify(user));
    this.setBase64ParsedAsToken();
  }

  getUserFromLocalStorage() {
    const u = localStorage.getItem(USER);
    const user = JSON.parse(u);
    return user;
  }

  private setBase64ParsedAsToken() {
    const user = this.getUserFromLocalStorage();
    if (user) {
      const token = 'Basic ' + btoa(user.username + ':' + user.password);
      localStorage.setItem(TOKEN, token);
    }
  }

  removeUser() {
    localStorage.clear();
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/service/authentication.service.ts